import { render } from "./CarouselItem.vue?vue&type=template&id=0c4417aa&scoped=true"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=0c4417aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4417aa"]])

export default __exports__